import { DataService } from "@/services/data";
import { Navigate, RouteObject } from "react-router-dom";

const TasksRoute: RouteObject = {
    path: "activites",
    async lazy() {
        let { TaskLayout } = await import("@/pages/tasks/layout");
        return { Component: TaskLayout };
    },
    children: [
        {
            index: true,
            element: <Navigate to="appels" replace />
        },
        {
            path: "appels",
            async lazy() {
                let { TaskCallPage } = await import("@/pages/tasks/calls");
                return { Component: TaskCallPage };
            },
            loader: async ({ request }) => {
                const { DEFAULT_DATE_RANGE } = await import("@/pages/tasks/calls");
                const url = new URL(request.url);
                url.searchParams.set("type", "call");
                url.searchParams.set("date__range", url.searchParams.get("date__range") || DEFAULT_DATE_RANGE);
                url.searchParams.set("page_size", url.searchParams.get("page_size") || "25");
                const tasks = await DataService.client
                    .url(`/apprenticeship/tasks/${url.searchParams ? "?" + url.searchParams.toString() : ""}`)
                    .get()
                    .json();
                return { tasks };
            }
        },
        {
            path: "messages",
            async lazy() {
                let { TaskMessagePage } = await import("@/pages/tasks/messages");
                return { Component: TaskMessagePage };
            },
            loader: async ({ request }) => {
                const { DEFAULT_DATE_RANGE } = await import("@/pages/tasks/messages");
                const url = new URL(request.url);
                url.searchParams.set("type", "sms");
                url.searchParams.set("date__range", url.searchParams.get("date__range") || DEFAULT_DATE_RANGE);
                url.searchParams.set("page_size", url.searchParams.get("page_size") || "25");
                const tasks = await DataService.client
                    .url(`/apprenticeship/tasks/${url.searchParams ? "?" + url.searchParams.toString() : ""}`)
                    .get()
                    .json();
                return { tasks };
            }
        },
        {
            path: "rappels",
            async lazy() {
                let { TaskEventPage } = await import("@/pages/tasks/event");
                return { Component: TaskEventPage };
            },
            loader: async ({ request }) => {
                const { DEFAULT_DATE_RANGE } = await import("@/pages/tasks/event");
                const url = new URL(request.url);
                url.searchParams.set("type", "event");
                url.searchParams.set("date__range", url.searchParams.get("date__range") || DEFAULT_DATE_RANGE);
                url.searchParams.set("owner_id", url.searchParams.get("owner_id") || "self");
                url.searchParams.set("page_size", url.searchParams.get("page_size") || "1000");
                const tasks = await DataService.client
                    .url(`/apprenticeship/tasks/${url.searchParams ? "?" + url.searchParams.toString() : ""}`)
                    .get()
                    .json();
                return { tasks };
            }
        }
    ]
};
export default TasksRoute;
